export { default } from './MainPlaceholder';
